/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Components/RecommendedBadge" />

import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { Pill, PillSize } from "VSSUI/Pill";

import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";

interface IRecommendedBadgeProps {
    isRecommended?: boolean;
    className?: string;
}

export class RecommendedBadge extends VssComponent<IRecommendedBadgeProps> {

    public render(): React.ReactNode {
        if (!this.props.isRecommended) {
            return null;
        }

        return (
            <Pill excludeFocusZone={true} excludeTabStop={true} className={this.props.className} size={PillSize.compact}>
                {Resources.RecommendedText}
            </Pill>);
    }
}
